import { ImpactType } from '../../types';

export const NUMBER_DESCRIPTOR_DATA_TYPE = 'NUMBER' as const;

export const EVENTS = {
    KEY_DOWN: 'keydown',
} as const;

export const DEFAULT_IMPACT_VALUES: ImpactType = {
    addedDescriptors: [],
    addedReports: [],
    updatedReports: [],
    rowMappings: [],
};
